import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { noop } from '../../../../lib/utils/common'
import { childrenPropType } from '../../../../lib/propTypes'
import selectPeriodEnhance, { buildTabID, buildPanelID } from './selectPeriodEnhance'
import CheckboxGroup from '../../../Shared/Form/CheckboxGroup'
import Tabs from '../../../Shared/Tabs/Tabs'

const SelectPricePeriod = ({
  id,
  label,
  tabs,
  tabAction,
  selectedValuesLabel,
  pricePeriodOptions,
  pricePeriodSelectedOption,
  pricePeriodYear,
  onChangePricePeriod,
  registerDropdown,
  onActiveChanged,
  footer,
  className = 'Dropdown--searchBar',
  DropdownComponent
}) => {
  let updatedTabs = [...tabs]

  if (updatedTabs[1] && updatedTabs[1].label === '') {
    updatedTabs = updatedTabs.slice(0, 1)
  }

  return (
    <DropdownComponent
      id={id}
      name={id}
      className={className}
      title={
        <Fragment>
          <div id={`${id}-label`} className='Dropdown-label'>{label}</div>
          <div>{selectedValuesLabel}</div>
        </Fragment>
      }
      ref={registerDropdown.bind(null, 'pricePeriod')}
      onActiveChanged={onActiveChanged}
      withAutofocus={false}
    >
      <div className='Dropdown-container Dropdown-container--stacked Dropdown-container--withoutPadding'>
        <div className='SelectRentalPeriod-wrapper'>
          <Tabs
            tabs={updatedTabs}
            tabAction={tabAction}
            tabsWrapperClassName='PricePeriodNav'
            tabClassName='PricePeriodNav-year'
            ariaLabel='Select year'
            withAutoFocus
          />
          <div className='SelectRentalPeriod-content'>
            <div role='tabpanel'
              id={buildPanelID(pricePeriodYear)}
              aria-labelledby={buildTabID(pricePeriodYear)}
              className='SelectRentalPeriod-panel'
            >
              <CheckboxGroup
                value={pricePeriodSelectedOption.length === 0 ? ['average_monthly_price'] : pricePeriodSelectedOption}
                options={pricePeriodOptions}
                onChange={onChangePricePeriod}
                identity={option => option.id}
                label={option => option.id === 'average_monthly_price' ? `${option.name} ${option.year}` : option.name}
                isDisabled={option => option.isDisabled === true}
                className='SelectRentalPeriod-checkboxGroup'
              />
            </div>
          </div>
          {footer && footer}
        </div>
      </div>
    </DropdownComponent>
  )
}

SelectPricePeriod.defaultProps = {
  registerDropdown: noop
}

SelectPricePeriod.propTypes = {
  id: PropTypes.string.isRequired,
  pricePeriodOptions: PropTypes.array.isRequired,
  pricePeriodSelectedOption: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  pricePeriodYear: PropTypes.string.isRequired,
  onChangePricePeriod: PropTypes.func.isRequired,
  label: PropTypes.string,
  selectedValuesLabel: PropTypes.string,
  tabs: PropTypes.arrayOf(PropTypes.shape({
    tabId: PropTypes.string.isRequired,
    panelId: PropTypes.string.isRequired,
    ref: PropTypes.object.isRequired,
    label: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    value: PropTypes.number.isRequired,
    isActive: PropTypes.bool
  }).isRequired),
  tabAction: PropTypes.func.isRequired,
  registerDropdown: PropTypes.func,
  onActiveChanged: PropTypes.func,
  footer: childrenPropType,
  className: PropTypes.string,
  DropdownComponent: PropTypes.elementType.isRequired
}

export default selectPeriodEnhance(SelectPricePeriod)

